module.exports = __webpack_public_path__ + "static/media/credit.f85628a0.svg";